// ==================== SEGURANÇA ====================
function sanitizeHandle(handle) {
  if (!handle) return '';
  return handle.replace(/[^a-z0-9\-\_]/gi, '');
}

// ==================== CONFIGURAÇÃO DO BACKEND ====================
// Centralized URL — set via theme.liquid bridge (window.KZ_BACKENDS).
var KZ_BACKEND_URL = (window.KZ_BACKENDS && window.KZ_BACKENDS.modalRec) || 'https://kz-recommendations.vercel.app';
var KZ_STORE = 'br';

var productMapping = {};

// ==================== CARREGAR DADOS DO BACKEND ====================

// Le metafield kz_modal.quiz renderizado SSR pelo Liquid.
// Pure sync read — script asset roda com defer apos HTML parsed.
function loadQuizData() {
  try {
    var el = document.getElementById('kz-modal-quiz-data');
    if (!el) return;
    var raw = el.textContent.trim();
    if (!raw || raw === 'null') return;
    var parsed = JSON.parse(raw);
    var data = (parsed && typeof parsed === 'object' && parsed.data) ? parsed.data : parsed;
    if (data && Object.keys(data).length > 0) {
      productMapping = data;
    }
  } catch (e) {}
}

// ==================== TRACKING ====================
function trackEvent(event, handle, title) {
  try {
    fetch(KZ_BACKEND_URL + '/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: event, handle: handle || null, title: title || null, store: KZ_STORE }),
      keepalive: true
    }).catch(function() {});
  } catch (e) {}
}

// ==================== VARIÁVEIS DO QUIZ ====================
var currentStep = 0;
var userAnswers = {};
var questionHistory = [];

// --- UTILITÁRIOS ---
var qs = function(selector) { return document.querySelector(selector); };
var qsa = function(selector) { return document.querySelectorAll(selector); };

// --- CUPOM ---
function copyCoupon() {
  var code = 'QUIZKZ10OFF';
  navigator.clipboard.writeText(code)
    .then(function() {
      var el = qs('.coupon-code');
      el.textContent = '✓ Copiado!';
      el.classList.add('coupon-copied');
      setTimeout(function() {
        el.textContent = code;
        el.classList.remove('coupon-copied');
      }, 2000);
    })
    .catch(function() { alert('Cupom: ' + code); });
}

function scrollToActiveQuestion() {
  setTimeout(function() {
    var activeQuestion = document.querySelector('.quiz-question.active');
    if (!activeQuestion) return;

    var rootStyles = getComputedStyle(document.documentElement);
    var headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10) || 0;
    var headerOffset = headerHeight + 24;
    var elementTop = activeQuestion.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: elementTop - headerOffset,
      behavior: 'smooth'
    });
  }, 100);
}

// --- STEP DOTS DINÂMICOS ---
function updateStepDots() {
  var maxQuestions = getQuizQuestionCount();
  qsa('.step-dot').forEach(function(dot, idx) {
    dot.classList.toggle('is-hidden', idx >= maxQuestions);
    dot.classList.remove('visible');
  });
}

// --- PROGRESS BAR ---
function getQuizQuestionCount() {
  if (!userAnswers.purpose) return 3;
  return userAnswers.purpose === 'retorno' ? 3 : 2;
}

function updateProgress() {
  var progressContainer = qs('.progress-container');
  if (progressContainer) progressContainer.classList.remove('is-hidden');

  var maxQuestions = getQuizQuestionCount();
  var progress = Math.min(((currentStep + 1) / maxQuestions) * 100, 100);
  qs('#progressFill').style.width = progress + '%';
  updateStepDots();

  var dots = qsa('.step-dot');
  dots.forEach(function(dot, idx) {
    if (dot.classList.contains('is-hidden')) return;
    dot.classList.toggle('active', idx <= currentStep);
    dot.classList.toggle('completed', idx < currentStep);
  });
}

// --- NAVEGAÇÃO PARA TRÁS ---
function goBack() {
  if (!questionHistory.length) return;
  var prev = questionHistory.pop();

  qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
  qs('.quiz-results').classList.remove('active');
  qs('[data-question="' + prev + '"]').classList.add('active');
  scrollToActiveQuestion();

  if (prev === '1') {
    currentStep = 0;
    userAnswers = {};
  } else if (prev.startsWith('2-')) {
    currentStep = 1;
    delete userAnswers.preference;
    delete userAnswers.fit;
  } else if (prev === '3-retorno') {
    currentStep = 2;
    delete userAnswers.fit;
  }
  updateProgress();
}

// --- AVANÇAR PERGUNTA ---
function nextQuestion(answer) {
  var currQ = qs('.quiz-question.active').getAttribute('data-question');
  questionHistory.push(currQ);

  if (currentStep === 0) {
    trackEvent('quiz_start');
    userAnswers.purpose = answer;
    currentStep = 1;
  } else if (currentStep === 1) {
    userAnswers.preference = answer;
    currentStep = userAnswers.purpose === 'retorno' ? 2 : 3;
  } else if (currentStep === 2) {
    userAnswers.fit = answer;
    currentStep = 3;
  }

  qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });

  if (currentStep === 1) {
    var nextQ = qs('[data-question="2-' + userAnswers.purpose + '"]');
    if (nextQ) nextQ.classList.add('active');
    scrollToActiveQuestion();
  } else if (currentStep === 2 && userAnswers.purpose === 'retorno') {
    var retornoQ = qs('[data-question="3-retorno"]');
    if (retornoQ) retornoQ.classList.add('active');
    scrollToActiveQuestion();
  } else if (currentStep === 3) {
    showResults();
    return;
  }
  updateProgress();
}

// --- RESULTADOS (XSS-SAFE com DOM API) ---
function showResults() {
  var progressContainer = qs('.progress-container');
  if (progressContainer) progressContainer.classList.add('is-hidden');

  trackEvent('quiz_complete');

  qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
  qs('.quiz-results').classList.add('active');

  var key = userAnswers.purpose === 'retorno'
    ? userAnswers.purpose + '-' + userAnswers.preference + '-' + normalizeFit(userAnswers.fit)
    : userAnswers.purpose + '-' + userAnswers.preference;

  var recommended = productMapping[key] || productMapping[getLegacyFitKey(key)] || [];
  var results = qs('#recommendedProducts');

  // Limpa resultados anteriores
  while (results.firstChild) {
    results.removeChild(results.firstChild);
  }

  if (recommended.length === 0) {
    var emptyDiv = document.createElement('div');
    emptyDiv.className = 'quiz-loading';
    var p1 = document.createElement('p');
    p1.textContent = 'Nenhum produto encontrado para esta combinação.';
    var p2 = document.createElement('p');
    p2.style.fontSize = '14px';
    p2.style.marginTop = '10px';
    p2.textContent = 'Tente outras opções ou entre em contato conosco!';
    emptyDiv.appendChild(p1);
    emptyDiv.appendChild(p2);
    results.appendChild(emptyDiv);
  } else {
    var delay = 0;

    recommended.forEach(function(product) {
      var card = document.createElement('div');
      card.className = 'product-card show';
      card.style.animationDelay = delay + 's';

      var price = parseFloat(product.price || 0);
      var formattedPrice = price.toLocaleString('pt-BR', { style: 'currency', currency: product.currency || 'BRL' });
      var variantNumericId = product.variantId ? product.variantId.split('/').pop() : '';
      var safeHandle = sanitizeHandle(product.handle);

      // Construir card via DOM API (XSS-safe)
      var imageWrapper = document.createElement('div');
      imageWrapper.className = 'product-image-wrapper';
      var img = document.createElement('img');
      img.src = product.image || 'https://placehold.co/400x220/1e293b/64748b?text=Produto';
      img.alt = product.name || '';
      img.className = 'product-image';
      img.loading = 'lazy';
      imageWrapper.appendChild(img);

      var info = document.createElement('div');
      info.className = 'product-info';

      var titleEl = document.createElement('h4');
      titleEl.className = 'product-title';
      if (window.KZVariantPicker && typeof window.KZVariantPicker.setTitle === 'function') {
        window.KZVariantPicker.setTitle(titleEl, product.name || '');
      } else {
        titleEl.textContent = product.name || '';
      }

      var priceEl = document.createElement('div');
      priceEl.className = 'product-price';
      priceEl.textContent = formattedPrice;

      var descEl = document.createElement('div');
      descEl.className = 'product-description';
      descEl.textContent = product.description || '';

      var buttonsDiv = document.createElement('div');
      buttonsDiv.className = 'product-buttons';

      var cartBtn = document.createElement('button');
      cartBtn.type = 'button';
      cartBtn.className = 'product-button add-to-cart-btn';
      cartBtn.textContent = 'Adicionar ao Carrinho';
      cartBtn.dataset.variant = variantNumericId;
      cartBtn.dataset.handle = safeHandle;
      cartBtn.dataset.title = product.name || '';
      cartBtn.dataset.price = String(price);
      cartBtn.dataset.currency = product.currency || 'BRL';
      cartBtn.addEventListener('click', function() {
        quizSmartAddToCart(this);
      });

      var viewBtn = document.createElement('a');
      viewBtn.href = '/products/' + safeHandle;
      viewBtn.className = 'product-button view-product-btn';
      viewBtn.textContent = 'Ver mais';
      viewBtn.addEventListener('click', function() {
        trackEvent('quiz_click', safeHandle, product.name);
      });

      buttonsDiv.appendChild(cartBtn);
      buttonsDiv.appendChild(viewBtn);

      info.appendChild(titleEl);
      info.appendChild(priceEl);
      info.appendChild(descEl);
      info.appendChild(buttonsDiv);

      card.appendChild(imageWrapper);
      card.appendChild(info);

      results.appendChild(card);
      delay += 0.1;
    });
  }

  setTimeout(function() {
    var resultsSection = qs('.quiz-results');
    if (!resultsSection) return;

    var rect = resultsSection.getBoundingClientRect();
    window.scrollTo({
      top: window.scrollY + rect.top - 170,
      behavior: 'smooth'
    });
  }, 300);
}

function normalizeFit(fit) {
  return fit === 'encaixe-menor' ? 'encaixe-menor' : 'encaixe-padrao';
}

function getLegacyFitKey(key) {
  if (!key) return '';
  if (key.endsWith('-encaixe-menor')) {
    return key.replace('-encaixe-menor', '-feminino');
  }
  if (key.endsWith('-encaixe-padrao')) {
    return key.replace('-encaixe-padrao', '-masculino');
  }
  return '';
}

// --- ADD TO CART VIA AJAX ---
async function addToCartAjax(variantId, handle, title, price, currency, btn) {
  var originalText = btn.textContent;
  btn.textContent = 'adicionando...';
  btn.disabled = true;

  try {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (response.ok) {
      trackEvent('quiz_atc', handle, title);

      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_name: title,
          content_type: 'product',
          currency: currency || 'BRL',
          value: parseFloat(price) || 0
        });
      }

      if (typeof gtag === 'function') {
        gtag('event', 'add_to_cart', {
          currency: currency || 'BRL',
          value: parseFloat(price) || 0,
          items: [{
            item_id: variantId,
            item_name: title,
            price: parseFloat(price) || 0,
            quantity: 1
          }]
        });
      }

      btn.textContent = '✓ adicionado!';

      var cartResponse = await fetch('/cart.js');
      var cart = await cartResponse.json();

      ['cart:refresh', 'theme:cart:change'].forEach(function(e) {
        document.documentElement.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: { cart: cart } }));
      });
      document.dispatchEvent(new CustomEvent('cart:build'));

      window.scrollTo({ top: 0, behavior: 'smooth' });

      setTimeout(function() {
        var drawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, [data-drawer-id="cart-drawer"]');
        if (drawer && drawer.open) { drawer.open(); return; }
        if (window.theme && window.theme.cartDrawer && window.theme.cartDrawer.open) { window.theme.cartDrawer.open(); return; }

        var cartIcon = document.querySelector('.Header__Icon--cart, [data-cart-trigger], [href="/cart"][data-action="open-drawer"], .header__cart-icon');
        if (cartIcon) cartIcon.click();
      }, 300);

      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);

    } else {
      throw new Error('Erro ao adicionar');
    }
  } catch (e) {
    btn.textContent = 'erro - tente novamente';
    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  }
}

/* Quiz add-to-cart with variant picker.
   The quiz only stores the first variant id on each card, so for
   multi-variant products it would silently add an arbitrary variant
   when the customer expects to choose. This wrapper fetches the
   full product on click, opens the shared KZVariantPicker dialog
   when there are real options, and falls back to the legacy direct
   add when the product has only the default variant (or when the
   fetch / picker fails). */
function quizSmartAddToCart(button) {
  var handle = button.dataset.handle;
  var variantId = button.dataset.variant;
  var title = button.dataset.title || '';
  var price = button.dataset.price || '';
  var currency = button.dataset.currency || 'BRL';
  var originalText = button.textContent;

  function fallbackDirect() {
    addToCartAjax(variantId, handle, title, price, currency, button);
  }

  if (!handle || !window.KZVariantPicker || typeof window.KZVariantPicker.openDialog !== 'function') {
    fallbackDirect();
    return;
  }

  button.disabled = true;
  button.textContent = '...';

  fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (productJs) {
      button.disabled = false;
      button.textContent = originalText;

      if (!productJs.variants || productJs.variants.length <= 1) {
        fallbackDirect();
        return;
      }

      window.KZVariantPicker.openDialog(
        window.KZVariantPicker.fromProductJs(productJs),
        {
          onAdded: function (variant) {
            var pickedPrice = (variant && variant.priceCents != null)
              ? (variant.priceCents / 100)
              : (parseFloat(price) || 0);
            var pickedId = variant && variant.id;
            trackEvent('quiz_atc', handle, title);
            if (typeof fbq === 'function') {
              fbq('track', 'AddToCart', {
                content_ids: [pickedId],
                content_name: title,
                content_type: 'product',
                currency: currency,
                value: pickedPrice
              });
            }
            if (typeof gtag === 'function') {
              gtag('event', 'add_to_cart', {
                currency: currency,
                value: pickedPrice,
                items: [{
                  item_id: pickedId,
                  item_name: title,
                  price: pickedPrice,
                  quantity: 1
                }]
              });
            }
          }
        }
      );
    })
    .catch(function () {
      button.disabled = false;
      button.textContent = originalText;
      fallbackDirect();
    });
}

// --- REINICIAR QUIZ ---
function restartQuiz() {
  currentStep = 0;
  userAnswers = {};
  questionHistory = [];
  updateProgress();
  qs('.quiz-results').classList.remove('active');
  qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
  qs('[data-question="1"]').classList.add('active');
  qs('.quiz-header').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// --- EFEITO DE PARTÍCULAS ---
function createParticles() {
  // Limita particulas ativas a 10
  var existing = document.querySelectorAll('.particle');
  if (existing.length >= 10) return;

  var count = 5;
  for (var i = 0; i < count; i++) {
    (function(idx) {
      setTimeout(function() {
        var p = document.createElement('div');
        p.className = 'particle';
        var w = Math.random() * 4 + 2;
        p.style.width = w + 'px';
        p.style.height = w + 'px';
        p.style.left = (Math.random() * 100) + '%';
        p.style.background = 'radial-gradient(circle, rgba(23,212,230,0.8) 0%, transparent 70%)';
        p.style.borderRadius = '50%';
        p.style.animationDelay = (Math.random() * 10) + 's';
        p.style.animationDuration = (Math.random() * 10 + 10) + 's';
        qs('#quiz-container').appendChild(p);
        setTimeout(function() { p.remove(); }, 20000);
      }, idx * 2000);
    })(i);
  }
}

// --- EVENTOS GERAIS ---
document.addEventListener('DOMContentLoaded', async function() {
  await loadQuizData();

  qsa('.quiz-option').forEach(function(option) {
    option.addEventListener('click', function() {
      var value = this.getAttribute('data-value');
      var self = this;
      self.style.transform = 'scale(0.95)';
      setTimeout(function() {
        self.style.transform = '';
        nextQuestion(value);
      }, 120);
    });
  });

  updateProgress();
  createParticles();
  setInterval(createParticles, 10000);

  if ('ontouchstart' in window) {
    qsa('.quiz-option').forEach(function(option) {
      option.addEventListener('touchstart', function() {
        this.style.transform = 'translateY(-5px) scale(1.02)';
      }, { passive: true });
      option.addEventListener('touchend', function() {
        var self = this;
        setTimeout(function() { self.style.transform = ''; }, 100);
      });
    });
  }
});
